import { httpResource } from '@angular/common/http';
import { Injector, signal } from '@angular/core';
import { injectApiUrl } from '@seatix/shared-config';
import { assertInjector } from 'ngxtension/assert-injector';
import { createInjectionToken } from 'ngxtension/create-injection-token';
import { ApiResponse } from '@seatix/shared-domain-utils';
import { User } from '@seatix/shared-domain-auth';
import { withExpectedUnauthorized } from '../auth-interceptor/auth-context';

export const [injectUserApiUrl, provideUserApiUrl] = createInjectionToken(
  () => {
    return injectApiUrl() + '/api/auth/me';
  },
);

export const [injectIsUserResourceActive, provideIsUserResourceActive] =
  createInjectionToken(() => {
    return signal(false);
  });

export function injectUserResource(injector?: Injector) {
  return assertInjector(injectUserResource, injector, () => {
    const apiUrl = injectUserApiUrl();
    const isActive = injectIsUserResourceActive();
    // /me asks whether the session cookie is still valid, so a 401 is its
    // expected "not logged in" answer. Keep it out of the interceptor's
    // logoutLocal(): that navigation would race the route guard's redirect to
    // login and replace the URL the user was opening. The store decides what a
    // 401 clears.
    return httpResource(
      () =>
        isActive()
          ? { url: apiUrl, context: withExpectedUnauthorized() }
          : undefined,
      {
        parse: (response) => (response as ApiResponse<User>).data,
      },
    );
  });
}
